import type { StoreHit } from '@/lib/algolia';

export interface BoutiquePickupProps {
  /** Locale string (e.g. "us-en") used for country filtering */
  lang: string;
  /** Currently selected store ID */
  value?: string;
  /** Callback when a boutique is selected */
  onChange: (storeId: string, store: StoreHit) => void;
  /** Error message for the field */
  error?: string;
}

export interface BoutiqueCardProps {
  store: StoreHit;
  selected: boolean;
  onSelect: () => void;
  lang: string;
}

export type Weekday = (typeof WEEKDAYS)[number];

export interface BoutiqueHoursRowProps {
  day: Weekday;
  hours: Record<string, { openIntervals: Array<{ start: string; end: string }> }>;
}

export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;
